<div class="time-field-container w-100">
  <label class="field-label" *ngIf="label">{{ label }}<span *ngIf="attributeDefinition.isRequired" class="required-asterisk"> *</span></label>
  <div class="input-wrapper">
    <ngx-timepicker-field
      [formControl]="control"
      [format]="format"
      [controlOnly]="true">
    </ngx-timepicker-field>
    <button mat-icon-button type="button" aria-label="Clear time" (click)="clear($event)"
      class="clear-button"
      [disabled]="control?.disabled || control?.value == null">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="error-message" *ngIf="control?.invalid && (control?.dirty || control?.touched)">
    {{ getErrorMessage() }}
  </div>
</div>